<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import uploadDocument from "../../../utils/digitalOcean/digitalocean-upload-file";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import proveedorContratistaAPI from "@/services/standards/crearProveedorContratista/proveedorContratistaAPI";
import Pagination from "@/components/standard/hazardIdentification/hazardPagination2";
import Swal from "sweetalert2";
import { sendNotification } from "@/utils/helpers/notification"
import CheckModal from "@/components/CheckModal"
import { dateFormat } from "@/utils/helpers/format";
import ItemAPI from "@/services/items/itemsAPI";
import newScoresAPI from "../../../services/newScores/newScoresAPI"
import revisionAnualAPI from "../../../services/standards/revisionAnual/revisionAnualAPI";
import ProveedoresEvaluacionPagination from "../../../components/standard/proveedoresEvaluacion2.10.1-1/ProveedoresEvaluacionPagination.vue";
import proveedoresEvaluacionAPI from "../../../services/standards/proveedoresEvaluacion/proveedoresEvaluacionAPI";
/**
 * Form elements component
 */
export default {
  page: {
    title: "2.10.1 Evaluación y selección de proveedores y contratistas",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    CheckModal,
    Pagination,
    ProveedoresEvaluacionPagination
  },
  data() {

    return {
      title: "2.10.1 Evaluación y selección de proveedores y contratistas",
      items: [

        {
          text: "Estandares",
          href: "/forms/estandares",
        },
        {
          text: "Evaluación y selección de proveedores",
          active: true,
        },
      ],

      colaboradorProveedor: [],
      evaluacion: [],
      lista: [],
      file: null,
      loading: true,
      acta: null,

      item: null,
      search: "",
      deleteCount: 0,
      itemData: null,

      evaluacionProveedores: {
        providers_contractors_id: null,
        companies_id: null,
        option: null,
        file: null,
        evaluation_providers_id: null,
        initial_date: null,
        final_date: null,
      },

      submitted: false,
      lastId: 1,
      nit: this.$store.getters["company/getCompany"].nit || null,
      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
      company: this.$store.getters["company/getCompany"] || null,

    };
  },
  methods: {

    getItemData() {
      ItemAPI.getItems(21)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;
        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"].company_classification_id || null;
          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    goPage(page) {
      window.location.href = page
    },

    fetch() {
      this.$refs.paginator.query();
    },

    dateConvert(date) {
      return dateFormat(date);
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 21)
        .then(response => {
          this.item = response || null
        })
        .catch(error => {
          console.log(error)
        })
    },

    /**
     * This method is used to send notification to SST user and SST company.
     * The sendNotification method import is required.
     * @param {Number} messageID - The message ID that will be associated to notification.
     * @param {Number} itemID - The item ID that will be associated to notification.
     * @param {Boolean} user - The user that will e associated to notification.
     * @return {Boolean} True if the notification is sent, false if not.
     */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(company.id, user ? company.id_diseno_sso : null, messageID, itemID);
    },

    /**
    * This method is used to knows if the user has the permission indicated
    * @param {String} name The name of the permission
    * @param {Array} roles the roles that permitted to access the action 
    * @returns {Boolean} true if the user has the permission indicated or false if no
    */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role ? this.$store.state.auth.info.role : null
      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false
        } // Close if the roles arrays is not empty
        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8
        } // Close if the roles arrays is empty
        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions
        // Know if the user has the permission indicated
        const enabled = permissions.find(permission => permission.name === name)
        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false
      } // Close if the user is logged
      // If the user is not logged
      else {
        return false
      } // Close else the user is not logged
    },

    /**
   * This method is used to redirect to the page indicated
   * @param {String} page The page to redirect
   */
    goPage(page) {
      window.location.href = page
    },

    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    async uploadDocument() {
      try {
        let url = "";
        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.nit}/2.10.1/${this.evaluacionProveedores.providers_contractors_id}/Evaluacion/${this.lastId}/${this.file.name}`;
        } else {
          url = `sst-prod/${this.nit}/2.10.1/${this.evaluacionProveedores.providers_contractors_id}/Evaluacion/${this.lastId}/${this.file.name}`;
        }
        const result = await uploadDocument(url, this.file);
        if (result) {
          this.evaluacionProveedores.file = `${process.env.VUE_APP_BUCKET}/${url}`;
          return true;
        } else return false;
      } catch (error) {
        console.log(error);
      }
    },

    getPC() {
      proveedorContratistaAPI.getAll()
        .then((response) => {
          this.loading = false
          let proveedorC = response.data.data;
          this.colaboradorProveedor = proveedorC
        })
        .catch((error) => {
          console.log(error);
          this.loading = false
        });
    },

    async save() {
      this.submitted = true;
      this.loading = true
      let response = await this.uploadDocument();
      if (response) {
        proveedoresEvaluacionAPI.saveEvaluacion(this.evaluacionProveedores)
          .then((response) => {
            const itemChange = {
              companies_id: this.companyID,
              item_id: 21,
              status: 'Pendiente',
            };
            newScoresAPI.calculateScores(itemChange)
              .then((response) => {
                this.sendNotification(40, 55, true)
                this.loading = false
                setTimeout(() => {
                  Swal.fire({
                    title: "¡Éxito!",
                    text: "¡Se ha registrado con éxito!",
                    icon: "success",
                    type: "success",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                }, 1000)
                window.location.reload();
              })
              .catch((error) => {
                this.loading = false
                setTimeout(() => {
                  Swal.fire({
                    title: "Error",
                    text: "¡No se ha podido registrar!",
                    icon: "error",
                    type: "error",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload();
                }, 1000);
                console.log(error);
              });
          })
          .catch((error) => {
            console.log(error);
            this.loading = false
          });
      } else {
        this.loading = false
        setTimeout(() => {
          Swal.fire({
            title: "¡Error!",
            text: "¡No se ha podido registrar!",
            icon: "warning",
            type: "warning",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
        }, 2000)
      }
    },

    deleteEvaluacion(id) {
      proveedoresEvaluacionAPI.deleteE(id)
        .then((data) => {
          if (this.deleteCount > 0) {
            this.deleteCount -= 1;
          }
          const newStatus = this.deleteCount > 0 ? 'Pendiente' : 'No Cumplido';
          const itemChange = {
            companies_id: this.companyID,
            item_id: 21,
            status: newStatus,
          };
          newScoresAPI.calculateScores(itemChange)
            .then((response) => {
              this.loading = false
              Swal.fire({
                title: "Éxito!",
                text: "Se ha sido eliminado con éxito!",
                icon: "success",
                type: "success",
                confirmButtonClass: "btn btn-confirm mt-2",
              });
              window.location.reload();
            })
            .catch((error) => {
              this.loading = false
              setTimeout(() => {
                Swal.fire({
                  title: "Error",
                  text: "¡No se ha podido registrar!",
                  icon: "error",
                  type: "error",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                window.location.reload();
              }, 1000);
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getActa() {
      revisionAnualAPI.getActa()
        .then((response) => {
          this.acta = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getEvaluacion() {
      proveedoresEvaluacionAPI.getShow(this.$route.params.id)
        .then((response) => {
          let evaluacionP = response
          this.evaluacion = evaluacionP
          this.loading = false
          this.evaluacionProveedores = {
            providers_contractors_id: response.providers_contractors_id,
            option: (response.option === 'Pooducto') ? 1 : 2,
            description: response.description,
            evaluation_providers_id: response.id,
            companies_id: this.companyID
          };
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getList() {
      proveedoresEvaluacionAPI.getAllSeleccion(this.$route.params.id)
        .then((response) => {
          let identificacion = response.data;
          this.lista = identificacion
          if (response.data[0]['id']) {
            this.lastId = response.data[0]['id'] + 1
          }
          if (Array.isArray(this.lista)) {
            this.deleteCount = this.lista.length;
          } else {
            this.deleteCount = 0;
          }
          this.loading = false
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async print() {
      try {
        revisionAnualAPI.getActa()
          .then((response) => {
            this.acta = response;
          })
        const url = this.acta;
        window.location.href = url;
      } catch (error) {
        console.log(error);
      }
    },

    async print1() {
      try {
        const url =
          "https://idmrnd3cibfs.compat.objectstorage.us-ashburn-1.oraclecloud.com/e-mision-sst/sst-prod/estandares/2.10.1/PROCEDIMIENTO%20DE%20SELECCION%20Y%20EVALUACION%20DE%20PROVEEDORES.docx";
        window.location.href = url;
      } catch (error) {
        console.log(error);
      }
    },

    async print2() {
      try {
        const url =
          "https://idmrnd3cibfs.compat.objectstorage.us-ashburn-1.oraclecloud.com/e-mision-sst/sst-prod/estandares/2.10.1/Formato%20guia%20seleccion%20de%20proveedor.xlsx";
        window.location.href = url;
      } catch (error) {
        console.log(error);
      }
    },

    async print3() {
      try {
        const url =
          "https://idmrnd3cibfs.compat.objectstorage.us-ashburn-1.oraclecloud.com/e-mision-sst/sst-prod/estandares/2.10.1/Formato%20gu%C3%ADa%20evaluacion%20de%20proveedor.xlsx";
        window.location.href = url;
      } catch (error) {
        console.log(error);
      }
    },

    goBack() {
      this.$router.go(-1);
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

  },

  mounted() {
    this.getActa();
    this.getItems();
    this.getList();
    this.getItemData();
    this.getPC();
    this.getEvaluacion();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12" v-if="!loading">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 col-sm-12">

                  <CheckModal>
                    <p class="text-justify">
                      En el Decreto 1072 de 2015 y en la Resolución 0312 de 2019 se solicita que la empresa cuente con
                      un procedimiento para la selección y evaluación de proveedores, el cual encontrará siguiendo el
                      link de procedimiento de selección y evaluación de proveedores.
                    </p>
                    <p class="text-justify">
                      Se deberá diligenciar el formato de selección de proveedores, indicando las empresas a las cuales
                      se le solicitó cotización y revisar los criterios de SST establecidos en el ítem 2.9.1, se
                      escogerá aquel proveedor que además de suplir las necesidades técnicas, garantice el cumplimiento
                      del SG SST.
                    </p>
                    <p class="text-justify">
                      Anualmente se deberá diligenciar el formato de evaluación de proveedores, midiendo el desempeño
                      del proveedor con respecto al SG SST.
                    </p>

                  </CheckModal>
                </div>

              </div>

              <div class="row pt-3">
                <div class="col-3 text-right m-b-0 mt-2">

                </div>
                <div class="col-1 text-right m-b-0">

                </div>
                <div class="col-4 text-right m-b-0">

                </div>
                <div class="col-4 text-right m-b-0">
                  <a href="#" @click="print1">
                    Procedimiento de selección y evaluación de proveedores
                  </a>
                  <br>
                  <a href="#" @click="print2">
                    Formato guía para la selección de proveedores
                  </a>
                  <br>
                  <a href="#" @click="print2">
                    Formato guía para la evaluación de proveedores
                  </a>
                  <br>

                </div>

              </div>

              <hr>

              <div class="row mt-2">
                <h4 class="header-title col-4">
                  Proveedor: {{ this.evaluacion.providers_contractors.name }}
                </h4>
              </div>

              <div class="row mt-2">
                <h4 class="header-title col-4">
                  Producto y/o servicio: {{ this.evaluacion.option }}
                </h4>
              </div>

              <div class="row mt-2">
                <h4 class="header-title col-4">
                  Descripción: {{ this.evaluacion.description }}
                </h4>
              </div>

              <form class="form-group" @submit.prevent="save">
                <div class="form-row pt-3">
                  <b-form-group class="col-md-4 px-2" label="Desde:" label-for="trainingDate">
                    <b-form-input :disabled="!allowAccess() || !getRole('Crear')" type="date" id="trainingDate"
                      v-model="evaluacionProveedores.initial_date">
                      >
                    </b-form-input>

                  </b-form-group>
                  <b-form-group class="col-md-4 px-2" label="Hasta:" label-for="trainingDate">
                    <b-form-input :disabled="!allowAccess() || !getRole('Crear')" type="date" id="trainingDate"
                      v-model="evaluacionProveedores.final_date">
                    </b-form-input>

                  </b-form-group>

                  <b-form-group class="col-md-4 px-2" label="Subir evidencia de selección" label-for="file">
                    <b-form-file :disabled="!getRole('Crear') || !allowAccess()" type="file" id="file" ref="file"
                      name="file" browse-text="Buscar" :placeholder="`Selecciona un archivo...`"
                      drop-placeholder="Suelta acá..." v-model="file" @change="uploadFile" v-on:change="uploadFile"
                      accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                    </b-form-file>
                  </b-form-group>
                </div>

                <div class="form-group text-right m-b-0">
                  <button :disabled="submitted" type="submit" class="btn btn-primary">Guardar</button>
                  <button type="button" class="btn btn-secondary mx-1" @click="goBack">Cancelar</button>
                </div>

                <hr v-if="getRole('Consultar')" />

                <div class="row" v-if="getRole('Consultar') || !allowAccess()">
                  <div class="col-lg-12">
                    <div class="card-body">
                      <div class="row pb-3">
                        <div class="col-6">
                          <form @submit.prevent="fetch()" class="form-inline">
                            <div class="form-group mr-2">

                              <b-form-input type="text" name="search" id="search" v-model="search" @update="fetch()"
                                class="form-control px-2" placeholder="Buscar"></b-form-input>

                              <div class="col-1">
                                <button type="submit" class="btn btn-primary px-2">Buscar</button>
                              </div>
                            </div>
                          </form>
                        </div>
                        <div class="col-6"></div>
                      </div>

                      <div class="table-responsive">
                        <table class="pt-2 table border-bottom divide-y divide-gray-200 table-striped rounded ">
                          <thead>
                            <tr>
                              <th class="text-center align-middle">Fecha de evaluacion</th>
                              <th class="text-center align-middle">Periodo a evaluar</th>
                              <th class="text-center align-middle">Ver archivo</th>
                              <th class="text-center align-middle">Acciones</th>
                            </tr>
                          </thead>
                          <tbody class="bg-white divide-y divide-gray-200">
                            <tr v-for="dato in lista" :key="dato.id">
                              <td class="text-center align-middle">
                                {{ dateConvert(dato.created_at) }}
                              </td>
                              <td class="text-center align-middle">
                                {{ dato.initial_date }} al {{ dato.final_date }}
                              </td>
                              <td class="text-center align-middle">
                                <div v-if="dato.file === null">
                                  <h6>No hay archivo disponible
                                  </h6>
                                </div>
                                <div v-else>
                                  <button :disabled="!allowAccess()"
                                    style=" background-color: transparent !important; border: none;" type="button"
                                    @click="gotoDigitalOcean(`${dato.file}`)"> <i class="mdi mdi-cloud-download"></i>
                                  </button>
                                </div>
                              </td>

                              <td class="text-center align-middle">
                                <div class="col-sm-12">
                                  <b-dropdown :disabled="!allowAccess()" variant="primary">
                                    <template v-slot:button-content>
                                      <i class="mdi mdi-eye"></i>
                                    </template>
                                    <b-dropdown-item :disabled="!getRole('Editar') || !allowAccess()"
                                      :to="{ path: `/forms/estandares/evaluacion-seleccion-proveedores2.10.1-1-editar/${dato.id}` }">
                                      Editar</b-dropdown-item>
                                    <b-dropdown-item :disabled="!getRole('Eliminar') || !allowAccess()"
                                      v-on:click="deleteEvaluacion(dato.id)">Eliminar</b-dropdown-item>
                                  </b-dropdown>
                                </div>
                              </td>
                            </tr>

                          </tbody>
                        </table>

                      </div>
                    </div>
                  </div>
                </div>

              </form>
            </div>
          </div>

        </div>

        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>